__turbopack_context__.v({
  "bottom-section": "b0KdUa_bottom-section",
  "bundle-banner-description": "b0KdUa_bundle-banner-description",
  "bundle-banner-one-year-plan-headline": "b0KdUa_bundle-banner-one-year-plan-headline",
  "bundle-banner-value-props": "b0KdUa_bundle-banner-value-props",
  "bundle-banner-wrapper": "b0KdUa_bundle-banner-wrapper",
  "bundle-logo": "b0KdUa_bundle-logo",
  "button": "b0KdUa_button",
  "feature-one": "b0KdUa_feature-one",
  "feature-three": "b0KdUa_feature-three",
  "feature-two": "b0KdUa_feature-two",
  "first-section": "b0KdUa_first-section",
  "float-features-item": "b0KdUa_float-features-item",
  "float-features-text": "b0KdUa_float-features-text",
  "float-features-wrapper": "b0KdUa_float-features-wrapper",
  "headline": "b0KdUa_headline",
  "main-image": "b0KdUa_main-image",
  "main-img-wrapper": "b0KdUa_main-img-wrapper",
  "money-back-guarantee": "b0KdUa_money-back-guarantee",
  "price": "b0KdUa_price",
  "pricing-logo-wrapper": "b0KdUa_pricing-logo-wrapper",
  "pricing-wrapper": "b0KdUa_pricing-wrapper",
  "second-section": "b0KdUa_second-section",
});
